"use client";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// data
export default function Footer() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    location: "",
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
    if (status.type) {
      setStatus({ type: "", message: "" });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.name.trim() || !formData.email.trim() || !formData.location.trim()) {
      setStatus({ type: "error", message: "Please fill out every field before submitting." });
      return;
    }

    setSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      await new Promise((resolve) => setTimeout(resolve, 800));
      setStatus({ type: "success", message: "Thanks for subscribing! We'll be in touch soon." });
      setFormData({ name: "", email: "", location: "" });
    } catch (error) {
      setStatus({ type: "error", message: "Unable to submit right now. Please try again later." });
    } finally {
      setSubmitting(false);
    }
  };

  const handleSectionNavigate = (event, target) => {
    event.preventDefault();
    navigate("/", {
      state: { scrollTarget: target },
    });
  };

  return (
    <div className="bg-black">
    <footer className="relative rounded-t-[48px] bg-gradient-to-l from-[#07174D] to-[#240F35] pt-9 text-white/90 sm:pt-15">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-14 lg:px-12">
        {/* Top row */}
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
          {/* Left: brand + nav + social */}
          <div className="text-center md:text-left">
            <button
              onClick={() => navigate("/")}
              className="flex items-center justify-center md:justify-start cursor-pointer hover:opacity-80 transition-opacity"
            >
              <img
                src="/images/nav.png"
                alt="SynergyCoin Logo"
                className="h-12 w-auto sm:h-14"
              />
            </button>

            {/* nav */}
            <nav className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-white/70 md:justify-start">
              <a
                href="#about"
                onClick={(event) => handleSectionNavigate(event, "about")}
                className="hover:text-white"
              >
                About us
              </a>
              <a
                href="#roadmap"
                onClick={(event) => handleSectionNavigate(event, "roadmap")}
                className="hover:text-white"
              >
                Roadmap
              </a>
              <a
                href="#listing"
                onClick={(event) => handleSectionNavigate(event, "listing")}
                className="hover:text-white"
              >
                Listing
              </a>
              <a
                href="#how"
                onClick={(event) => handleSectionNavigate(event, "how")}
                className="hover:text-white"
              >
                How to buy
              </a>
              <a
                href="#faq"
                onClick={(event) => handleSectionNavigate(event, "faq")}
                className="hover:text-white"
              >
                FAQ
              </a>
            </nav>

            {/* socials */}
            <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-white/80 md:justify-start">
              {/* Facebook */}
              <a
                aria-label="Facebook"
                href="/"
                className="grid h-9 w-9 place-items-center rounded-full bg-white/[0.06] transition hover:bg-white/[0.12]"
              >
                <img
                  src="/images/Facebook.svg"
                  alt="Facebook"
                  className="h-5 w-5 object-contain"
                />
              </a>

              {/* Instagram */}
              <a
                aria-label="Instagram"
                href="/"
                className="grid h-9 w-9 place-items-center rounded-full bg-white/[0.06] transition hover:bg-white/[0.12]"
              >
                <img
                  src="/images/Instagram.svg"
                  alt="Instagram"
                  className="h-5 w-5 object-contain"
                />
              </a>

              {/* X (Twitter) */}
              <a
                aria-label="X"
                href="/"
                className="grid h-9 w-9 place-items-center rounded-full bg-white/[0.06] transition hover:bg-white/[0.12]"
              >
                <img
                  src="/images/X.svg"
                  alt="X (Twitter)"
                  className="h-5 w-5 object-contain"
                />
              </a>

              {/* LinkedIn */}
              <a
                aria-label="LinkedIn"
                href="/"
                className="grid h-9 w-9 place-items-center rounded-full bg-white/[0.06] transition hover:bg-white/[0.12]"
              >
                <img
                  src="/images/LinkedIn.png"
                  alt="LinkedIn"
                  className="h-5 w-5 object-contain"
                />
              </a>

              {/* YouTube */}
              <a
                aria-label="YouTube"
                href="/"
                className="grid h-9 w-9 place-items-center rounded-full bg-white/[0.06] transition hover:bg-white/[0.12]"
              >
                <img
                  src="/images/Youtube.svg"
                  alt="YouTube"
                  className="h-5 w-5 object-contain"
                />
              </a>
            </div>
          </div>

          {/* Right: Subscribe */}
          <div className="text-center md:pl-8 md:text-left">
            <div className="text-base font-semibold">Subscribe</div>
            <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-3 text-left">
              <div className="flex flex-col gap-3 sm:flex-row">
                <div className="flex flex-1 flex-col gap-1 text-sm text-white/70">
                  <label htmlFor="footer-name">Name</label>
                  <input
                    id="footer-name"
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full rounded-md border border-white/15 bg-white px-4 py-3 text-sm text-black placeholder:text-gray-500 outline-none focus:border-purple-400 focus:ring-2 focus:ring-purple-300/60"
                  />
                </div>
                <div className="flex flex-1 flex-col gap-1 text-sm text-white/70">
                  <label htmlFor="footer-email">Email</label>
                  <input
                    id="footer-email"
                    type="email"
                    name="email"
                    placeholder="Your email address"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full rounded-md border border-white/15 bg-white px-4 py-3 text-sm text-black placeholder:text-gray-500 outline-none focus:border-purple-400 focus:ring-2 focus:ring-purple-300/60"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1 text-sm text-white/70">
                <label htmlFor="footer-city">City/State</label>
                <input
                  id="footer-city"
                  type="text"
                  name="location"
                  placeholder="Your City/State"
                  value={formData.location}
                  onChange={handleChange}
                  className="w-full rounded-md border border-white/15 bg-white px-4 py-3 text-sm text-black placeholder:text-gray-500 outline-none focus:border-purple-400 focus:ring-2 focus:ring-purple-300/60"
                />
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="mt-2 rounded-md bg-gradient-to-r from-[#A855F7] to-[#7C3AED] px-5 py-3 text-sm font-semibold text-white transition hover:from-[#9c4bff] hover:to-[#6a28e2] disabled:cursor-not-allowed disabled:opacity-70"
              >
                {submitting ? "Submitting…" : "Submit"}
              </button>
            </form>
            {status.message && (
              <p
                className={`mt-2 text-xs ${
                  status.type === "error" ? "text-red-300" : "text-emerald-300"
                }`}
              >
                {status.message}
              </p>
            )}
            <p className="mt-3 text-xs text-white/60">
              By subscribing you agree to our{" "}
              <Link to="/privacy-policy" className="underline hover:text-white">
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>

        {/* Divider */}
        <hr className="mt-10 border-white/10" />

        {/* Bottom row */}
        <div className="mt-6 flex flex-col-reverse gap-4 text-center text-sm text-white/70 md:flex-row md:items-center md:justify-between md:text-left">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 md:justify-start">
            <Link to="/privacy-policy" className="underline hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="underline hover:text-white">
              Terms of Service
            </Link>
            <Link to="/cookie-settings" className="underline hover:text-white">
              Cookies Settings
            </Link>
          </div>

          <div className="text-white/60">© 2025 SynergyCoin. All rights reserved.</div>
        </div>
      </div>
    </footer>
    </div>
  );
}
